import { useContext } from 'react';

import { OrganizationContext } from 'containers/GlobalWrapper/BusinessOrganizationDataValidation';
import { isFeatureAccessible } from 'containers/GlobalWrapper/offer/FeatureAccessibility';
import { useFeatureFlags } from 'contexts/FeatureFlagsProvider';
import { useFetchCurrentOfferQuery } from 'redux/api/subscriptions.api';

export const useOverSeatLimitOffer = () => {
  const featureFlags = useFeatureFlags();
  const businessOrganization = useContext(OrganizationContext);
  const { data: currentPlan } = useFetchCurrentOfferQuery(
    { organizationId: businessOrganization?.id },
    { skip: !businessOrganization?.id },
  );

  const isOverSeatLimitOffer =
    businessOrganization?.used_licenses_count > (currentPlan?.total_user_plan || 0) &&
    isFeatureAccessible(
      businessOrganization?.id,
      currentPlan?.offer_id,
      'seats_limit',
      featureFlags,
    )?.isFeatureAccessible;

  return { isOverSeatLimitOffer, currentPlan };
};
